import { render, staticRenderFns } from "./EducationPatientFooter.vue?vue&type=template&id=60cc13a7&scoped=true"
import script from "./EducationPatientFooter.vue?vue&type=script&lang=js"
export * from "./EducationPatientFooter.vue?vue&type=script&lang=js"
import style0 from "./EducationPatientFooter.vue?vue&type=style&index=0&id=60cc13a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc13a7",
  null
  
)

export default component.exports